import React from "react";
import { Link } from "react-router-dom";
import { Clock, MapPin, Users, ArrowRight, Plane, Ship } from "lucide-react";
import { PageHero } from "../components/site/Common";
import { SeoExtras, ROUTES_BY_SLUG } from "../components/site/SeoExtras";
import { RelatedLinks } from "../components/site/RelatedLinks";
import { FLEET, SERVICE_PAGES } from "../mock";

const EYEBROW = { airport: "Corfu Airport transfer", port: "Corfu Port transfer", private: "Private transfer in Corfu" };

const RoutePage = ({ slug }) => {
  const r = ROUTES_BY_SLUG[slug];
  const svc = SERVICE_PAGES[r.hub];
  const book = `/book?type=oneway&pickup=${encodeURIComponent(r.fromLoc)}&dropoff=${encodeURIComponent(r.toLoc)}`;
  const HubIcon = r.hub === "port" ? Ship : Plane;
  return (
    <div data-testid="route-page">
      <PageHero image={svc.image} eyebrow={EYEBROW[r.hub]} title={r.h1 || `${r.from} to ${r.to}`}
        sub={r.intro || `Private door-to-door transfer from ${r.from} to ${r.to} with a fixed price per vehicle, meet & greet and free child seats.`}>
        <div className="mt-6 flex flex-wrap gap-2.5 text-[14px] text-[#F7F3EA]">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-white/15 backdrop-blur px-3.5 py-1.5"><Clock className="w-4 h-4" />~{r.minutes} min</span>
          <span className="inline-flex items-center gap-1.5 rounded-full bg-white/15 backdrop-blur px-3.5 py-1.5"><MapPin className="w-4 h-4" />{r.km} km</span>
          <span className="inline-flex items-center gap-1.5 rounded-full bg-white/15 backdrop-blur px-3.5 py-1.5"><HubIcon className="w-4 h-4" />from €{r.prices[0]}</span>
        </div>
      </PageHero>
      <section className="max-w-7xl mx-auto px-6 pt-10 sm:pt-16">
        <h2 className="font-serif-d text-[22px] sm:text-[28px] font-semibold text-[#183C35]">Fixed prices per vehicle</h2>
        <div className="mt-4 grid sm:grid-cols-3 gap-3" data-testid="route-prices">
          {FLEET.map((v, i) => (
            <div key={v.id} className="bg-white rounded-2xl border border-[#183C35]/10 p-5 flex items-center justify-between gap-3">
              <div>
                <p className="font-medium text-[#183C35]">{v.name}</p>
                <p className="text-[13px] text-[#202522]/60 inline-flex items-center gap-1"><Users className="w-3.5 h-3.5" />{v.paxText}</p>
              </div>
              <p className="font-serif-d text-[26px] text-[#183C35]" data-testid={`route-price-${v.id}`}>€{r.prices[i]}</p>
            </div>
          ))}
        </div>
        <p className="mt-3 text-[13px] text-[#202522]/55">Taxes, tolls, luggage and child seats included. Price is per vehicle, not per person.</p>
        <Link to={book} className="mt-6 inline-flex items-center gap-2 rounded-full bg-[#183C35] text-[#F7F3EA] px-7 py-3.5 font-medium hover:bg-[#21524A] transition-colors" data-testid="route-book-btn">
          Book {r.from} to {r.to} <ArrowRight className="w-4 h-4" />
        </Link>
      </section>
      <SeoExtras path={`/${slug}`} page={`route-${slug}`} />
      <RelatedLinks current="" />
    </div>
  );
};

export default RoutePage;
